<template>
  <b-form-select
    class="analyze-layer-type-selector"
    v-bind:value="value"
    v-bind:options="options"
    v-on="$listeners"
  />
</template>

<script>
/**
 * 分析マップ種類セレクターコンポーネント
 */
export default {
  name: 'AppAnalyzeLayerTypeSelector',
  props: {
    /**
     * 値
     * @model
     */
    value: {
      type: String,
      default: null,
    },
    /**
     * 選択肢
     */
    options: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.analyze-layer-type-selector {
  color: $entity-color-black;
  pointer-events: auto;
  height: 40px;
  min-width: 200px;
  border: none;
  border-radius: 4px;
  padding-left: 1.25rem;
  font-weight: 700;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('../../assets/ifield/icon_arrow_down.svg');
  background-size: 32px 32px;
  background-position: right 0.25rem center;
  cursor: pointer;

  &:focus {
    border-color: none;
    box-shadow: none;
  }
}
</style>
